<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3 scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-white b-b">
					<a class="navbar-brand">Configuration</a>
					<a class="btn-nav-topright b-l ml-0" href="/#/landing">
						<div>
							<i class="fas fa-th-large fa-fw" />
							Home
						</div>
					</a>
				</div>

				<div class="content-main">
					<div class="padding text-center h-100 d-flex flex-column justify-content-center">
						<h2 class="text-muted mb-4">
							<span class="text-theme">{{ brand.name }}™</span> Configuration
						</h2>
						<h5 class="text-muted mb-4 d-lg-none">
							Please use the
							<i class="far fa-bars fa-fw"></i> menu at the top left to navigate.
						</h5>
						<h5 class="text-muted mb-4 d-none d-lg-block">Please use the side bar to navigate.</h5>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
</style>

<script>
import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();

export default {
	name: "Config",

	props: ["user"],

	data() {
		return {
			brand: brand
		};
	},
	components: {},
	created() {},
	methods: {}
};
</script>





// WEBPACK FOOTER //
// src/vues/Landing/Config.vue